import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorRouting } from './error-routing.module';
import { NotFoundPage } from './not-found/not-found.page';
import { ServerUnavailablePage } from './server-unavailable/server-unavailable.page';
import { ServerUnavailableService } from './server-unavailable/server-unavailable.service';
import { CustomerNotFoundPage } from './customer-not-found/customer-not-found.page';

@NgModule({
  imports: [
    CommonModule,
    ErrorRouting,
  ],
  declarations: [
    CustomerNotFoundPage,
    NotFoundPage,
    ServerUnavailablePage,
  ],
  providers: [
    ServerUnavailableService,
  ],
})
export class ErrorsModule {}



// WEBPACK FOOTER //
// ./src/app/pages/errors/error.module.ts